import React from "react"
import OrderList from "../components/OrderList/OrderList"
import { OrderListContextProvider } from "../components/OrderList/OrderListContext"

const OrderListContainer = () => {
  return (
    <div>
      <OrderListContextProvider>
        <OrderList />
      </OrderListContextProvider>
    </div>
  )
}

export default OrderListContainer
